<div
  class="d-flex gap-3 align-items-center justify-content-between"
  *ngIf="addAndRemoveStatus">
  <span>
    <p-menu
      *ngIf="userAddTableData.length >= 0"
      id="navbarDropdown1"
      [popup]="true" />
    <a
      class="action-btn link add d-flex gap-2 text-decoration-none align-items-center"
      *ngIf="userAddTableData.length >= 0"
      id="navbarDropdown1"
      (click)="popover.toggle($event)">
      <i class="pi pi-plus-circle"></i>
      <div>Add</div>
    </a>
  </span>

  <a
    class="delcol d-flex gap-2 text-decoration-none align-items-center"
    (click)="deleteUserSupport()">
    <i class="pi pi-minus-circle"></i> Remove</a
  >
</div>
<p-popover #popover>
  <form class="profile-form">
    <p-listbox
      [options]="userAddTableData"
      [checkbox]="true"
      [showToggleAll]="false"
      [multiple]="true"
      (onClick)="onClick($event)"
      [filter]="true"
      optionLabel="name">
    </p-listbox>

    <div class="d-flex d-flex justify-content-end importuser-button">
      <p-button
        label="Import Users"
        [raised]="true"
        (click)="importUsersHandler(popover)"
        class="fullwdth secondary-btn mt-2" />
    </div>
  </form>
</p-popover>
